(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-password-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/company-details-password-form.js');
"use strict";

const _React = React,
  useContext = _React.useContext,
  Fragment = _React.Fragment;
const EDIT_MODE_PASSWORD = svs.ticket_partner.companyDetails.constants.actions.EDIT_MODE_PASSWORD;
const _svs$ticket_partner$c = svs.ticket_partner.companyDetails.constants.TEXTS,
  CANCEL_LABEL = _svs$ticket_partner$c.CANCEL_LABEL,
  SAVE_LABEL = _svs$ticket_partner$c.SAVE_LABEL,
  PASSWORD_LABEL = _svs$ticket_partner$c.PASSWORD_LABEL;
const _svs$ticket_partner$c2 = svs.ticket_partner.companyDetails.constants.TEXTS.CHANGE_PASSWORD,
  HEADER = _svs$ticket_partner$c2.HEADER,
  PASSWORD = _svs$ticket_partner$c2.PASSWORD;
const ButtonRow = svs.ticket_partner.sharedComponents.buttonRow.ButtonRow;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow;
const Icon = svs.ui.ReactIcon;
const INFO_TEXT = svs.ticket_partner.companyDetails.constants.TEXTS.INFO_TEXT;
const CompanyDetailsPasswordForm = () => {
  const ChangePasswordForm = svs.ticket_partner.changePassword.ChangePasswordForm;
  const _useContext = useContext(svs.ticket_partner.CompanyDetailsContext),
    dispatch = _useContext.dispatch,
    state = _useContext.state;
  const passwordEdit = state.password.edit;
  const edit = state.companyDetails.edit;
  const saveAndCancelBtnsPass = [{
    className: 'margin-right-1',
    label: CANCEL_LABEL,
    key: 'cancel-btn',
    transparent: true,
    onClick: e => {
      e.preventDefault();
      dispatch({
        type: EDIT_MODE_PASSWORD,
        payload: {
          edit: false
        }
      });
    }
  }, {
    label: SAVE_LABEL,
    key: 'save-btn',
    inverted: true,
    type: 'submit'
  }];
  const editPassBtn = [{
    label: PASSWORD_LABEL,
    key: 'edit-btn',
    inverted: true,
    onClick: e => {
      e.preventDefault();
      dispatch({
        type: EDIT_MODE_PASSWORD,
        payload: {
          edit: true
        }
      });
    }
  }];
  const onPasswordChanged = () => {
    dispatch({
      type: EDIT_MODE_PASSWORD,
      payload: {
        edit: false
      }
    });
  };
  if (edit) {
    return null;
  }
  return React.createElement(GridCol, {
    className: "u-text-left",
    md: 6,
    sm: 12
  }, React.createElement("h2", null, HEADER), passwordEdit ? React.createElement(ChangePasswordForm, {
    customButtons: saveAndCancelBtnsPass,
    isLessSpace: true,
    isVertical: false,
    onPasswordChanged: onPasswordChanged
  }) : React.createElement(Fragment, null, React.createElement("div", null, PASSWORD), React.createElement(ButtonRow, {
    buttons: editPassBtn,
    className: "margin-top-2"
  })), React.createElement(Fragment, null, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement("div", {
    className: "u-flex u-flex-align-items-center "
  }, React.createElement(Icon, {
    icon: "information"
  }), React.createElement("p", {
    className: "f-bold f-small f-margin-0 margin-top-2 margin-left-1 margin-right-1"
  }, INFO_TEXT)))));
};
svs.ticket_partner.companyDetails.components.CompanyDetailsPasswordForm = CompanyDetailsPasswordForm;

 })(window);